import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine';
import { TypedMemo } from '../../common/types';
import styles from './SMLChartEmpty.module.scss';

interface SMLChartEmptyProps {
  title: string;
  text: string;
}

/**
 * An empty chart that names the cause instead of shrugging. The action, when
 * there is one, comes in as a child — only the caller knows what fixes it.
 */
const SMLChartEmptyComponent: React.FC<React.PropsWithChildren<SMLChartEmptyProps>> = ({ title, text, children }) => {
  return (
    <div className={styles.empty}>
      <span className={styles.icon}>
        <FontAwesomeIcon icon={faChartLine} />
      </span>
      <b className={styles.title}>{title}</b>
      <p className={styles.text}>{text}</p>
      {children}
    </div>
  );
};

export const SMLChartEmpty = TypedMemo(SMLChartEmptyComponent);
